import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { FilterOrganizations } from 'containers/filters'
import { Table, Data } from 'components/layout/Table'
import { Status } from 'components/misc'
import { awardUnits as awardUnitsLayout } from 'constants/layout'
import { apiOrganizations } from 'helpers/decorators/api'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import { Export } from 'containers/misc'
import config from 'config'
import { ORGANIZATION_HIERARCHY } from '../../../constants/enums'

const enhance = compose(
  meta({
    title: 'Award Units',
    intlKey: 'pageTitle.award_units'
  }),
  permissions(),
  apiOrganizations({
    list: true,
    filter: 'awardUnitsOrIacs',
    useCommonLimit: true
  }),
  tableCommon()
)

class AwardUnitsList extends Component {
  static propTypes = {
    permissions: PropTypes.object.isRequired,
    organizations: PropTypes.object.isRequired,
    organizationHierarchyId: PropTypes.number,
    setOrganizationsParams: PropTypes.func,
    exportOrganizations: PropTypes.func.isRequired,
    isDetail: PropTypes.bool,
    setCommonLimit: PropTypes.func
  }

  static defaultProps = {
    routes: []
  }

  state = {
    organizationHierarchyId: null
  }

  render() {
    const {
      organizations,
      organizations: { loading, list, offset, limit, pages, sort, filter },
      setOrganizationsParams,
      permissions: userPermissions,
      isDetail,
      setCommonLimit
    } = this.props

    const isGOP = true
    const { organizationHierarchyId } = this.state
    const exportComponent = (
      <Export
        exportName="Award units"
        toExport={this.props.exportOrganizations}
        exportSchemeValue="award-units"
        count={organizations && organizations.count}
      />
    )

    return (
      <div>
        <FilterOrganizations
          isDetail={isDetail}
        />
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          filter={filter}
          ths={awardUnitsLayout.tableHeaders({
            organizationHierarchyId: organizationHierarchyId ||
              this.props.organizationHierarchyId,
            isDetail,
            isGOP
          })}
          setParams={setOrganizationsParams}
          data={organizations}
          permissions={userPermissions}
          exportComponent={exportComponent}
        >
          <Data>
            {list.map(({
              id,
              globalId,
              name,
              region,
              parentOA,
              parentSubOA,
              parent,
              organizationType,
              organizationState,
              coordinators,
              parentNAO,
              hierarchyLevel
            }) => {
              let coordinatorName = '---'

              if (coordinators && coordinators.length > 0) {
                const leadCoordinators = coordinators.filter(c => c.isLeadCoordinator)

                if (leadCoordinators.length > 0) {
                  const leadCoordinator = leadCoordinators[0]

                  coordinatorName = (get(leadCoordinator, 'firstName')
                    || get(leadCoordinator, 'person.firstName')
                    || '---')
                    + ' ' + (
                      get(leadCoordinator, 'lastName')
                      || get(leadCoordinator, 'person.lastName')
                    )
                }
              }

              return (
                <tr key={id}>
                  <td>
                    {get(hierarchyLevel, 'value') === ORGANIZATION_HIERARCHY.AU.value && <Link to={{ pathname: `${config.publicPath}/award-units/${id}/detail` }}>{globalId}</Link>}
                    {get(hierarchyLevel, 'value') === ORGANIZATION_HIERARCHY.IAC.value && <Link to={{ pathname: `${config.publicPath}/independent-award-centres/${id}/detail` }}>{globalId}</Link>}
                  </td>
                  <td>{name}</td>
                  <td>
                    {coordinatorName}
                  </td>
                  <td>{get(organizationType, 'translationText')}</td>
                  {(userPermissions.isGopStaff || userPermissions.isNaoStaff || userPermissions.isIfSuper) &&
                    <td>{get(parentOA, 'name') || '---'}</td>}
                  {!isDetail &&
                    userPermissions.isOa &&
                    <td>{get(parentSubOA, 'name') || '---'}</td>}
                  {userPermissions.isIf &&
                    !isDetail &&
                    <td>
                      {organizationHierarchyId
                        ? get(parent, 'name')
                        : get(parentNAO, 'name') || '---'}
                    </td>}
                  {userPermissions.isIfSuper &&
                    !isDetail &&
                    <td>{get(region, 'name')}</td>}
                  <td>
                    <Status state={organizationState} />
                  </td>
                </tr>
              )
            })}
          </Data>
        </Table>
      </div>
    )
  }
}

export default enhance(AwardUnitsList)
